var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import queries from 'constants/queries';
import { PatientArea } from 'models';
import { useQuery } from 'react-query';
import ApiService from './ApiService';
var PatientAreaService = /** @class */ (function (_super) {
    __extends(PatientAreaService, _super);
    function PatientAreaService() {
        var _this = _super.call(this) || this;
        _this.patientAreasRoot = 'patient_areas';
        return _this;
    }
    PatientAreaService.prototype.usePatientAreas = function () {
        var _this = this;
        return useQuery(queries.patientAreas, function () {
            return _this.get(_this.patientAreasRoot);
        }, {
            select: function (response) {
                var data = response.data;
                return plainToClass(PatientArea, data);
            }
        });
    };
    PatientAreaService.prototype.getPatientAreaDataByID = function (patientAreas, id) {
        return patientAreas === null || patientAreas === void 0 ? void 0 : patientAreas.find(function (patientArea) { return patientArea.getId() === id; });
    };
    PatientAreaService.getInstance = function () {
        if (!PatientAreaService.patientAreaService) {
            PatientAreaService.patientAreaService = new PatientAreaService();
        }
        return PatientAreaService.patientAreaService;
    };
    return PatientAreaService;
}(ApiService));
export default PatientAreaService;
